import throttle from "just-throttle";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initFormModal } from "./partials/form-modal";

// Expose globally for inline scripts in template-parts
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

import OverlayMenu from "@lib/beskar-overlay-menu/bskr-overlay-menu.mjs";

const adminBarOffset = parseInt(
  getComputedStyle(document.documentElement).getPropertyValue(
    "--wp-admin--admin-bar--height"
  )
);

function updateAdminBarOffset(visible) {
  const header = document.getElementById("header");
  const fixedElement = document.querySelector(".is-position-sticky");

  if (fixedElement) {
    if (visible) {
      fixedElement.style.setProperty(
        "--bskr--header-height",
        header.offsetHeight + "px"
      );
    } else {
      fixedElement.style.setProperty("--bskr--header-height", 0 + "px");
    }
  }
}

function initLenisScroll() {
  const lenis = new Lenis({
    prevent: function (element) {
      return element.classList.contains("no-lenis");
    },
  });
  window.lenisInstance = lenis;

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  return { lenis, addEventListener, gsapTicker: gsap.ticker };
}

let isHeaderHidden = false;

function toggleHeaderOnMenu(
  header,
  args = { duration: 0.5, ease: "power4.out" }
) {
  document.body.classList.toggle("on-menu-opened");
  const isHidden = toggleHeader(header, args);
  gsap.to(header, {
    yPercent: isHidden ? -100 : 0,
    ...args,
  });
}

function showHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  gsap.to(header, {
    yPercent: 0,
    ...args,
  });
}

function hideHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  gsap.to(header, {
    yPercent: -100,
    ...args,
  });
}

function toggleHeader(header, args = { duration: 0.5, ease: "power4.out" }) {
  isHeaderHidden = !isHeaderHidden;
  !isHeaderHidden ? hideHeader(header, args) : showHeader(header, args);
  return isHeaderHidden;
}

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);
  initFormModal();

  const isDesktop = window.innerWidth >= 1024;

  let lenis = isDesktop ? initLenisScroll().lenis : null;

  const header = document.getElementById("header");
  const overlayMenu = new OverlayMenu("main", { options: { duration: 1 } });

  if (overlayMenu) {
    overlayMenu.addEvent(
      "onOpen",
      throttle(() => {
        lenis?.stop();
        toggleHeaderOnMenu(header);
      }, 10)
    );

    overlayMenu.addEvent(
      "onClosed",
      throttle(() => {
        lenis?.start();
        toggleHeaderOnMenu(header);
      }, 10)
    );
  }

  window.showHeader = () => showHeader(header);
  window.hideHeader = () => hideHeader(header);
  window.toggleHeader = () => toggleHeader(header);

  // Header scroll state: gradient → solid background
  if (header) {
    ScrollTrigger.create({
      trigger: document.body,
      start: "top -50px",
      onToggle: (self) => header.classList.toggle("is-scrolled", self.isActive),
    });
  }

  // Language Selector
  const langSelector = document.querySelectorAll(".language-selector");

  if (langSelector) {
    langSelector.forEach((selector) => {
      selector.addEventListener("change", function () {
        window.location.href = this.value;
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (process.env.NODE_ENV === "development") {
    console.log("Development mode enabled.");
  }
});
